"use strict";

define('view/notifications',['require','exports','module','underscore','marionette','libs/spf.helper','libs/scroll.handler','templates','uikit/uikit'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var SPFHelper = require('libs/spf.helper');
  var ScrollHandler = require('libs/scroll.handler');
  var Templates = require('templates');
  var UIKit = require('uikit/uikit');
  var NotificationsView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    className: 'notifications',
    template: Templates.IRB['notifications'],
    events: {
      "keydown #notifications-menu > ul a": "navigateBetweenItems",
      "keydown #notifications-menu": "handleKeydownNotifications",
      "keydown #notifications-menu ul": "navigateToDefaultItems",
      "click #notifications-menu": "openSubmenu"
    },
    ui: {
      scrollContainer: '.scroll-container'
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.scrollHandler = new ScrollHandler();
      this.proxyEventsFrom(this.scrollHandler);
      this.on('show', function () {
        document.getElementById('notificationsHeader').focus();
      });
      this.once('before:render', function () {
        if (this.options.childView) {
          this.table.columns.add({
            childView: this.options.childView
          });
        }
        if (this.options.canRemove) {
          this.table.columns.add({
            data: 'delete',
            childView: UIKit.Button,
            childViewOptions: {
              icon: 'remove',
              basicText: true,
              size: 'small',
              stopPropagation: true,
              ariaLabel: 'close notification'
            },
            collapsing: true
          });
        }
      }, this);
      this.actions.childBindings = {
        text: 'text',
        link: 'link'
      };
      this.actions.collection = new Backbone.Collection([{
        text: 'Mark All Read',
        action: 'markAllRead',
        link: '#'
      }]);
      this.actions.on('press', function (model) {
        this.trigger('action', model.get('action'), model);
      }, this);
      if (this.options.canDeleteAll) {
        this.actions.collection.push({
          text: 'Delete All',
          action: 'deleteAll',
          link: '#'
        });
      }
      this.actions.collection.push({
        text: 'Mute Notifications',
        action: 'toggleMuteNotifications',
        link: '#'
      });
    },
    navigateBetweenItems: function navigateBetweenItems(event) {
      event.preventDefault();
      event.stopPropagation();
      var items = $("#notifications-menu ul a");
      var selectedItemIndex = items.index(event.target);
      if (event.key === "ArrowDown") {
        $(items[selectedItemIndex + 1]).focus();
      }
      if (event.key === "ArrowUp") {
        $(items[selectedItemIndex - 1]).focus();
      }
    },
    handleKeydownNotifications: function handleKeydownNotifications(event) {
      if (["Enter", " "].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        this.openSubmenu();
        this.navigateToDefaultItems(event);
      }
      if (event.key === "Tab") {
        var navMenu = $("#notifications-menu");
        if (navMenu.hasClass("visible")) {
          navMenu.removeClass("active visible");
          navMenu.attr({
            "aria-expanded": "false"
          });
          $("#notifications-menu > ul").removeClass("transition visible");
        }
      }
    },
    navigateToDefaultItems: function navigateToDefaultItems(event) {
      var items = $("#notifications-menu ul a");
      if (event.key === "ArrowDown") {
        $(items[0]).focus();
      }
      if (event.key === "ArrowUp") {
        $(items[items.length - 1]).focus();
      }
    },
    openSubmenu: function openSubmenu() {
      var navMenu = $("#notifications-menu");
      if (!navMenu.hasClass("visible")) {
        navMenu.addClass("active visible");
        navMenu.attr({
          "aria-expanded": "true"
        });
        $("#notifications-menu > ul").addClass("transition visible");
      }
    },
    onRender: function onRender() {
      this.scrollHandler.setElement(this.ui.scrollContainer);
    },
    onBeforeRender: function onBeforeRender() {
      if (this.options.width != null) {
        this.$el.width(this.options.width);
      }
    },
    onDestroy: function onDestroy() {
      this.scrollHandler.off().stopListening();
    }
  });
  module.exports = NotificationsView;
});

